var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spinner-snake-wrapper" }, [
    _c("div", {
      staticClass: "spinner-snake",
      style: {
        "border-top-color": _vm.spinnerColor,
        "border-left-color": _vm.spinnerColor,
        "border-bottom-color": _vm.spinnerColor,
        height: _vm.spinnerSize,
        width: _vm.spinnerSize
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a3f3bb5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3f3bb5e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/avatar-crop/loading.vue
// module id = 122
// module chunks = 0